import { Component, Input, OnInit } from '@angular/core';

import { TopicCountModel } from 'src/app/model';

@Component({
  selector: 'app-topic-count',
  templateUrl: './topic-count.component.html',
  styleUrls: ['./topic-count.component.css']
})
export class TopicCountComponent implements OnInit {

  @Input() list: TopicCountModel[] = [];

  constructor() { }

  ngOnInit(): void { }

}
